module.exports = __webpack_public_path__ + "static/mobile-malvertising-15f8fef378cfc12559cf700520a67727.gif";